module.exports = __webpack_public_path__ + "static/media/tyre-red-4.c6cea5fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/tyre-red-4.png
// module id = 1143
// module chunks = 0